export default "__VITE_ASSET__BASOHX0j__"